import React, { useState } from "react";
import "../../Styles/Form/thanksPage.css";
import ThanksImage from "../../Assets/ThanksImage.png";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const ThanksComponent = () => {
  const tanksData = {
    image: ThanksImage,
    text: "Thank You!",
    description: "Your submission has been received.",
  };
  const [generalSettings, setGeneralSetting] = useState();
  const [responseSetting, setResponsesSetting] = useState();
  const [thanksImage, setThanksImage] = useState();
  const [thanksText, setThanksText] = useState();
  const userId = useParams().userId;
  const formId = useParams().formId;
  const url = process.env.REACT_APP_API;
  const getDefaultImage = async (type) => {
    console.log(type);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/forms/retrieve`,
        { fileKey: type }
      );
      return response.data.url; // Return the URL
    } catch (error) {
      console.error("Error fetching default image:", error);
      return null; // Return fallback value for failed requests
    }
  };
  useEffect(() => {
    const formDetails = async () => {
      try {
        const responses = await axios.get(`${url}/forms/${formId}`);
        if (responses.status === 200) {
          setResponsesSetting(responses.data.form.responseSettings);
          setGeneralSetting(responses.data.form.generalSettings);
          setThanksImage(
            await getDefaultImage(
              responses.data.form.thanksSettings.customThanksPage.image
            )
          );

          setThanksText(
            responses.data.form.thanksSettings.customThanksPage
              .thanksDescription
          );
        }
      } catch (error) {
        console.error(error);
      }
    };
    formDetails();
  }, [formId, url]);

  //open another tag to view score
  const handleViewScoreClick = () => {
    window.open(`/view-score/${formId}/${userId}`, "_blank");
  };

  const openEditingUserResponse = async () => {
    try {
      const response = await axios.get(`${url}/forms/${formId}`);
      if (response.status === 200) {
        // Filter responses based on userId
        response.data?.form?.sections?.map((section) => {
          return {
            ...section,
            questions: section.questions.map((question) => {
              return {
                ...question,
                responses: question.responses.filter(
                  (response) => response.userId === userId
                ),
              };
            }),
          };
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="user_Response_container">
      <div className="thanks-container">
        <div className="thanks-image-container">
          <img
            src={thanksImage ? thanksImage : tanksData.image}
            alt={tanksData.text}
          />
        </div>
        <div className="thanks-text-container">
          <h1>{tanksData.text}</h1>
          <p>{thanksText ? thanksText : tanksData.description}</p>
        </div>
      </div>
      <div></div>
      <div className="another-response-container">
        <div style={{ display: "flex", gap: "1rem" }}>
          <p>Submit another Response</p>
          {responseSetting?.allowResponseEditing && (
            <p onClick={openEditingUserResponse}>Edit response</p>
          )}
        </div>
        {generalSettings?.quizSettings.showMarkEachSubmission && (
          <button
            style={{ display: "flex", alignItems: "center", marginTop: "0" }}
            onClick={handleViewScoreClick}
          >
            View score
          </button>
        )}
      </div>
      <p className="Report-abuse">
        This content is neither created nor endorsed by Stacia. Report
        Abuse - Terms of Service - Privacy Policy
      </p>
    </div>
  );
};

export default ThanksComponent;
